import { BellRing, LayoutDashboard, Megaphone, Users, type LucideIcon } from "lucide-react";

export interface NavItem {
  to: string;
  labelKey: string;
  icon: LucideIcon;
}

export interface NavSection {
  /** Sarlavhasiz bo'lim — `null`. */
  titleKey: string | null;
  items: NavItem[];
}

export const NAV_SECTIONS: NavSection[] = [
  { titleKey: null, items: [{ to: "/", labelKey: "nav.dashboard", icon: LayoutDashboard }] },
  {
    titleKey: "nav.sectionManage",
    items: [
      { to: "/users", labelKey: "nav.users", icon: Users },
      { to: "/deliveries", labelKey: "nav.deliveries", icon: BellRing },
      { to: "/announcements", labelKey: "nav.announcements", icon: Megaphone },
    ],
  },
];

export const NAV_ITEMS: NavItem[] = NAV_SECTIONS.flatMap(section => section.items);

/** Bo'lim faol: `/users/123` ham "Foydalanuvchilar" ni yoqadi, `/` esa faqat o'zi. */
export function isActive(pathname: string, to: string): boolean {
  if (to === "/") return pathname === "/";
  return pathname === to || pathname.startsWith(`${to}/`);
}
